<template lang='pug'>
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon list
            h4.title
              | {{ $t("webChannel.channelParameters.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              .md-layout
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.channelParameters.subitems.clerk"
                    | )
                    | }}
                  md-input(v-model='canalWebData.assistantName')
                md-field(style='margin-top: 30px')
                  label
                    | {{
                    | $t(
                    | "webChannel.channelParameters.subitems.mentionDefaultMessage"
                    | )
                    | }}
                  md-input(v-model='canalWebData.mentionDefaultMessage')
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.channelParameters.subitems.welcome"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.welcomeText' md-autogrow)
              .md-layout(style='margin-top: 10px;')
                //- .md-layout-item(style='margin: auto; padding-left: 0; padding-bottom: 4px;')
                //-   h4
                //-     | {{
                //-     | $t(
                //-     | "webChannel.channelParameters.subitems.message"
                //-     | )
                //-     | }} &nbsp;
                //- //-    span(style='font-size: 12px;') ({{$t("webChannel.channelParameters.subitems.textIsConvertedToHtml")}})
              .md-layout
                .md-layout-item(style='padding: 0; margin: auto;')
                  //- quill-editor(
                  //-     class="editor"
                  //-     ref="myTextEditor"
                  //-     :value="createHtml(canalWebData.message)"
                  //-     :options="editorOption"
                  //-     @change="onEditorChange($event)"
                  //-   )
                //- md-field(style='margin-top: 30px')
                //-   label
                //-     | {{
                //-     | $t(
                //-     | "webChannel.channelParameters.subitems.disabledMessage"
                //-     | )
                //-     | }}
                //-   md-input(v-model='canalWebData.disabledMessage')
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.channelParameters.subitems.sessionFinish"
                    | )
                    | }}
                  md-input(v-model='canalWebData.intentionalTerminationMessage')
              .md-layout
                .md-layout-item(style='padding: 0; margin: auto;')
                  //- quill-editor(
                  //-     class="editor"
                  //-     ref="myTextEditor"
                  //-     :value="createHtml(canalWebData.message)"
                  //-     :options="editorOption"
                  //-     @change="onEditorChange($event)"
                  //-   )
                  //- md-field(style='margin-top: 30px')
                  //-   label
                  //-     | {{
                  //-     | $t(
                  //-     | "webChannel.channelParameters.subitems.disabledMessage"
                  //-     | )
                  //-     | }}
                  //-   md-input(v-model='canalWebData.disabledMessage')
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.channelParameters.subitems.messageInactivity"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.messageInactivity' md-autogrow)

</template>

<script>
import dedent from 'dedent'
import hljs from 'highlight.js'
import debounce from 'lodash/debounce'
import { quillEditor } from 'vue-quill-editor'
import 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'
export default {
  components: { quillEditor },
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      // Locais
      editorOption: {
        modules: {
          'emoji-toolbar': true,
          'emoji-shortname': true,
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['emoji', 'link'],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean']
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value
          }
        }
      }
    }
  },
  methods: {
    onEditorChange: debounce(function (
      value
    ) {
      this.canalWebData.message = value.html
    },
    466),
    createHtml (text) {
      return dedent`${text}`
    }
  }
}
</script>
